import script from "./cotizacionList.vue?vue&type=script&setup=true&lang=ts"
export * from "./cotizacionList.vue?vue&type=script&setup=true&lang=ts"

import "./cotizacionList.vue?vue&type=style&index=0&id=f325f6fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f325f6fc"]])

export default __exports__